import { useState } from "react";
import Card from "../../../modules/Card";
import Input from "../../../modules/Input";
import CartOrderDeliveryDetails from "./CartOrderDeliveryDetails/CartOrderDeliveryDetails";
import CartOrderFulfilmentDetails from "./CartOrderFulfilmentDetails/CartOrderFulfilmentDetails";
import ImageLinks from "../../../assets/Images/ImagesLink";
import { formatCurrencyCountry } from "../../../resources/internationalizationUtils";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function CartOrderDetails({
  pickup_otp,
  set_pickup_otp,
  delivery_otp,
  set_delivery_otp,
  partner_fee_details,
  total_amount,
  gst_amount,
  partnersList,
  titanPrice,
  titanNetwork,
  set_partner_fee_details,
  fulfilmentType,
  setFulfilmentType,
  isTitanAI,
  setTitanAI,
  packageWeight,
  setPackageWeight,
  orderId,
  setOrderId,
}) {
  const [scheduledDate, setScheduledDate] = useState(new Date());

  const userDetails = useSelector((state) => state.app.user_details);
  const currency_code = userDetails?.currency || "DEFAULT";

  const handleOrderIdChange = (e) => {
    const value = e.target.value;

    const isValid = /^[a-zA-Z0-9]{0,14}$/.test(value);

    if (isValid) {
      setOrderId(value);
    }
  };

  const handlePackageWeightChange = (e) => {
    const value = e.target.value;

    const isValid = /^\d*\.?\d{0,2}$/.test(value);

    if (isValid) {
      setPackageWeight(value);
    }
  };

  const surge_with_gst = parseFloat(
    partner_fee_details?.quote?.price_breakup?.surge || 0,
  );

  const surge_charge = (surge_with_gst / (1 + 0.18)).toFixed(2);
  const { t } = useTranslation();

  return (
    <>
      <Card>
        {/* Order Details */}
        <div>
          <div className="text-stone-900 text-sm font-bold mb-2">
            {t("order_details")}
          </div>
          <div className="space-y-5">
            <div className="flex justify-between items-center">
              <div className="text-stone-500 text-xs font-semibold">
                {t("order_number")}*
              </div>
              <div className="">
                <Input value={orderId} onChange={handleOrderIdChange} />
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-full text-stone-500 text-xs font-semibold">
                {t("package_weight")}*
              </div>
              <div className="">
                <Input
                  value={packageWeight}
                  onChange={handlePackageWeightChange}
                  rightIcon="kg"
                />
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="text-stone-500 text-xs font-semibold">
                {t("verify_otp")}*
              </div>
              <div className="flex items-center space-x-4">
                <label
                  className="flex items-center cursor-pointer"
                  onClick={() => set_pickup_otp(!pickup_otp)}
                >
                  <span
                    className={`flex items-center justify-center w-4 h-4 rounded border ${
                      pickup_otp
                        ? "bg-dark_purple border-dark_purple"
                        : "bg-white border-gray"
                    }`}
                  >
                    {pickup_otp && (
                      <img
                        src={ImageLinks.check}
                        className="w-4 h-4"
                        alt="check"
                      />
                    )}
                  </span>
                  <p className="ms-2 font-semibold text-xs text-dark_gray">
                    {t("on_pickup")}
                  </p>
                </label>
                <label
                  className="flex items-center cursor-pointer"
                  onClick={() => set_delivery_otp(!delivery_otp)}
                >
                  <span
                    className={`flex items-center justify-center w-4 h-4 rounded border ${
                      delivery_otp
                        ? "bg-dark_purple border-dark_purple"
                        : "bg-white border-gray"
                    }`}
                  >
                    {delivery_otp && (
                      <img
                        src={ImageLinks.check}
                        className="w-4 h-4"
                        alt="check"
                      />
                    )}
                  </span>
                  <p className="ms-2 font-semibold text-xs text-dark_gray">
                    {t("onn_delivery")}
                  </p>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="my-6 h-[1px] bg-neutral-200" />

        {/* Fulfilment Details  */}
        <div>
          <div className="text-stone-900 text-sm font-bold mb-4">
            {t("fulfilment_details")}
          </div>
          <div className="space-y-5">
            <div className="flex justify-between items-center">
              <div className="text-stone-500 text-xs font-semibold">
                {t("delivery_partner")}
              </div>
              <CartOrderDeliveryDetails
                partnersList={partnersList}
                isTitanAI={isTitanAI}
                setTitanAI={setTitanAI}
                titanPrice={titanPrice}
                titanNetwork={titanNetwork}
                set_partner_fee_details={set_partner_fee_details}
              />
            </div>
            <div className="flex justify-between items-center">
              <div className="text-stone-500 text-xs font-semibold">
                {t("fulfilment_type")}
              </div>
              <div className="text-stone-900 text-xs font-bold">
                {t("deliver_now")}
              </div>
            </div>
          </div>
        </div>

        <div className="my-6 h-[1px] bg-neutral-200" />

        {/* Payment Details  */}
        <div>
          <div className="text-stone-900 text-sm font-bold mb-4">
            {t("payment_details")}
          </div>
          <div className="space-y-5">
            <div className="flex justify-between items-center">
              <div className="text-stone-500 text-xs font-semibold">
                {t("delivery_fee")}
              </div>
              <div className="text-stone-900 text-xs font-bold">
                {
                  formatCurrencyCountry(
                    partner_fee_details?.quote?.price_breakup
                      ?.base_delivery_charge || 0,
                    currency_code,
                  )?.formatedAmount
                }
              </div>
            </div>
            {partner_fee_details?.quote?.price_breakup?.surge &&
            partner_fee_details?.quote?.price_breakup?.surge > 0 ? (
              <div className="flex justify-between items-center">
                <div className="text-stone-500 text-xs font-semibold">
                  {t("surge_charge")}
                </div>
                <div className="text-stone-900 text-xs font-bold">
                  {
                    formatCurrencyCountry(surge_charge, currency_code)
                      ?.formatedAmount
                  }
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="flex justify-between items-center">
              <div className="text-stone-500 text-xs font-semibold">
                {t("platform_fee")}
              </div>
              <div className="text-stone-900 text-xs font-bold">
                {
                  formatCurrencyCountry(
                    partner_fee_details?.platform_fee,
                    currency_code,
                  )?.formatedAmount
                }
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="text-stone-500 text-xs font-semibold">
                {t("gst_amount")}
              </div>
              <div className="text-stone-900 text-xs font-bold">
                {
                  formatCurrencyCountry(gst_amount || 0, currency_code)
                    ?.formatedAmount
                }
              </div>
            </div>
          </div>
        </div>

        <div className="my-6 h-[1px] bg-neutral-200" />
        <div className="flex justify-between items-center">
          <div className="text-stone-500 text-base font-bold">
            {t("total_amount")}
          </div>
          <div className="text-stone-900 text-xs font-bold">
            {
              formatCurrencyCountry(total_amount || 0, currency_code)
                ?.formatedAmount
            }
          </div>
        </div>
      </Card>
    </>
  );
}

export default CartOrderDetails;
